"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TextButton = function TextButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      href = _ref.href,
      iconPosition = _ref.iconPosition,
      block = _ref.block,
      disabled = _ref.disabled,
      loading = _ref.loading,
      onClick = _ref.onClick,
      attrs = (0, _objectWithoutProperties2.default)(_ref, ["className", "children", "href", "iconPosition", "block", "disabled", "loading", "onClick"]);
  var classes = (0, _classnames.default)('TextButton', {
    'TextButton-block': block
  }, {
    'TextButton-loading': loading
  }, (0, _defineProperty2.default)({}, "TextButton-with-icon-".concat(iconPosition), iconPosition), className);
  var tag = href ? 'a' : 'button';
  var opts = (0, _objectSpread2.default)({
    className: classes,
    disabled: disabled,
    onClick: onClick,
    href: href
  }, attrs);

  if (!href) {
    opts.type = 'button';
  }

  return _react.default.createElement(tag, opts, children);
};

TextButton.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The markup node to insert into the button. */
  children: _propTypes.default.node,

  /** The url to send the link to, if applicable. If provided, will turn button into an anchor element. */
  href: _propTypes.default.node,

  /** If an icon is provided, whether to add the margin to the icon on the left or right side. */
  iconPosition: _propTypes.default.oneOf(['left', 'right']),

  /** Whether the button should display as a block level element. */
  block: _propTypes.default.bool,

  /** Whether the button is disabled or not. */
  disabled: _propTypes.default.bool,

  /** Whether to show a loading animation inside of the button. */
  loading: _propTypes.default.bool,

  /**
   * The handler to execute when the button is clicked.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onClick: _propTypes.default.func
};
var _default = TextButton;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TextButton, "TextButton", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/TextButton/TextButton.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/TextButton/TextButton.jsx");
  leaveModule(module);
})();

;